import React, { useContext } from "react";
import { QuizContext } from '../contexts/quizContext'

export default function ScoreBoard() {
  const { quiz } = useContext(QuizContext)
  
  return (
    <div id="scoreboard">
      { quiz.scores.map( (score, index) => (
        <img src={ score === 1 ? 
              `https://icon.now.sh/check_circle/007600/20` : `https://icon.now.sh/info/990000/20`} 
              alt=""
              key={index} />
      ))}
    </div>
  );
}
